// extracted by mini-css-extract-plugin
export default {"taskChipWrapper":"tracking_taskChipWrapper__il2ZO","trackingContainer":"tracking_trackingContainer__phHVw"};